import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="py-28 px-6 bg-hero-gradient text-brand-white text-center" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-63">
          Tu consultorio profesional empieza hoy
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl font-sans font-light text-brand-white/90 mb-12" data-id="element-64">
          Acceso inmediato. Una sola inversión. Resultado de por vida.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8" data-id="element-65">
          <a href="https://gana-con-conocimiento.myshopify.com/cart/52148248248603:1" className="w-full sm:w-auto px-10 py-5 bg-brand-gold text-brand-white text-lg font-bold rounded-full hover:bg-brand-gold/90 transition-all duration-300 shadow-lg hover:shadow-brand-gold/30 hover:-translate-y-1" data-id="element-66">
            Quiero el Megapack — $19.990
          </a>
          <a href="https://gana-con-conocimiento.myshopify.com/cart/52148953874715:1" className="w-full sm:w-auto px-10 py-5 bg-transparent border-2 border-brand-white/30 text-brand-white text-lg font-bold rounded-full hover:bg-brand-white/10 transition-all duration-300" data-id="element-67">
            Edición Avanzada — $27.990
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-brand-white/60 text-sm font-sans" data-id="element-68">
          Precio de lanzamiento. Sin fecha de vencimiento confirmada.
        </motion.p>
      </div>
    </section>;
}